export function getFirstDayOfCurrentMonth() {
  const date = new Date()

  return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
}

export function getLastMonths(count) {
  const date = new Date()
  const months = []
  for (let i = 0; i < count; i++) {
    const temp = new Date(
      date.getFullYear(),
      date.getMonth() - i,
      1,
      0,
      0,
      0,
      0
    )

    months.push(
      `${(temp.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${temp.getFullYear()}`
    )
  }

  return months
}

export function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
}

export function getHourMinutesSeconds(date) {
  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
}
